import { VOLUME_IN_OPTION_VALUES } from 'constants/businessTool';

import { ReactComponent as DollarIcon } from 'assets/icons/DollarIcon.svg';
import { ReactComponent as PcsIcon } from 'assets/icons/PcsIcon.svg';
import { ReactComponent as PercentageIcon } from 'assets/icons/PercentageIcon.svg';

import { AdornmentIcon } from 'components/BusinessToolForm/components/AdornmentIcon/AdornmentIcon';

import { IAdornmentIconMapType } from './types';

export const adornmentIconMap: IAdornmentIconMapType = {
  [VOLUME_IN_OPTION_VALUES.PIECES.value]: <AdornmentIcon text='justUnits.pieces'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.DOLLAR.value]: <DollarIcon />,
  [VOLUME_IN_OPTION_VALUES.PERCENTAGE.value]: <PercentageIcon />,
  [VOLUME_IN_OPTION_VALUES.ORDERS.value]: <AdornmentIcon size="l" text='justUnits.orders'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.PACKS.value]: <AdornmentIcon text='justUnits.packs'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.LITER.value]: <AdornmentIcon text='justUnits.liter'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.KILOGRAM.value]: <AdornmentIcon text='justUnits.kilograms'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.TONNE.value]: <AdornmentIcon text='justUnits.tonnes'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.POUND.value]: <AdornmentIcon text='justUnits.pounds'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.CUBIC_METER.value]: (
    <AdornmentIcon text='justUnits.cubic_meter'>
    </AdornmentIcon>
  ),
  [VOLUME_IN_OPTION_VALUES.GALLON.value]: <AdornmentIcon text='justUnits.gallon'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.ACRE.value]: <AdornmentIcon text='justUnits.acre'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.KILOWATT_HOUR.value]: <AdornmentIcon text='justUnits.kilowatt_hour'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.SQUARE_METER.value]: (
    <AdornmentIcon text='justUnits.square_meter'>
    </AdornmentIcon>
  ),
  [VOLUME_IN_OPTION_VALUES.GIGABYTE.value]: <AdornmentIcon text='justUnits.gigabyte'></AdornmentIcon>,

  [VOLUME_IN_OPTION_VALUES.HOURS.value]: <AdornmentIcon text='justUnits.hours'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.BARREL.value]: <AdornmentIcon text='justUnits.barrel'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.UNITS.value]: <AdornmentIcon text='justUnits.units'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.FEET.value]: <AdornmentIcon text='justUnits.feet'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.SQUARE_FEET.value]: (
    <AdornmentIcon text='justUnits.square_feet'>
    
    </AdornmentIcon>
  ),
  [VOLUME_IN_OPTION_VALUES.CUBIC_FEET.value]: (
    <AdornmentIcon text='justUnits.cubic_feet'>
    
    </AdornmentIcon>
  ),
  [VOLUME_IN_OPTION_VALUES.OUNCES.value]: <AdornmentIcon text='justUnits.ounces'></AdornmentIcon>,
  [VOLUME_IN_OPTION_VALUES.MILES.value]: <AdornmentIcon text='justUnits.miles'></AdornmentIcon>,
};
